// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_dr-0";
export var actionModalContentContainer = "_dr-1";
export var createTagButton = "_dr-2";
export var footerContainer = "_dr-7";
export var fullWidthDivider = "_dr-3";
export var hasCreateTagButton = "_dr-4";
export var noCreateTagButton = "_dr-5";
export var tagsContainer = "_dr-6";
export var tagsModalContentContainer = "_dr-8";